// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + "948ed687a48f978567a0" + ".chunk.js");